// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7261) return "static/chunks/7261.efc26a56403564ae.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2234":"27fa107e","9149":"14aeac6e"}[chunkId] || chunkId) + "-" + {"974":"5e3724f08013616f","1890":"57411a9116176fd7","2234":"3b311ece6e69afe7","4789":"7b447c0f8edd55a4","5843":"6e92cbeb0dd84c4f","6670":"6e4481f1e6f93608","9118":"85bf10e859c11435","9149":"636e332fc1d5e23f"}[chunkId] + ".js";
};